// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"13fcc82d","349":"f4e50076","695":"f4e50076","7106":"f4e50076","7360":"46e64be5","8645":"f4e50076"}[chunkId] + ".chunk.css";
};